import React, { Component } from 'react'

import { withGoogleMap, GoogleMap } from 'react-google-maps'
import { compose } from 'react-apollo'

import PropTypes from 'prop-types'

class Map extends Component {
  static propTypes = {
    defaultZoom: PropTypes.number.isRequired,
    defaultCenter: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number
    }),
    center: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number
    }),
    markers: PropTypes.arrayOf(PropTypes.node),
    createRef: PropTypes.func.isRequired
  }

  static defaultProps = {
    defaultZoom: 16,
    defaultCenter: {
      lat: 37.7749295,
      lng: -122.41941550000001
    }
  }

  render() {
    let markers
    let center

    if (this.props.markers) {
      markers = this.props.markers
    }

    center = this.props.center || this.props.defaultCenter

    return (
      <GoogleMap
        defaultZoom={this.props.defaultZoom}
        center={center}
        ref={map => {
          this.props.createRef(map)
        }}
      >
        {markers}
      </GoogleMap>
    )
  }
}

export default compose(withGoogleMap)(Map)



// WEBPACK FOOTER //
// src/components/TripPlanner/Map.js